import React, { useEffect, useMemo, useState } from 'react';
import { InsightsAgents } from '@axtria/hqi-configurator';
import '@axtria/hqi-configurator/lib/hqi-configurator.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFunctionsAndGoals, fetchRoles } from '../../actions/app.action';
import Loader from '../../components/Loader';
import { toPortfolioRoles } from '../../utils/roleAdapter';
const baseURL = process.env.REACT_APP_HQI_BASE_URL
const middlewareURL = process.env.REACT_APP_HQI_MIDDLEWARE_URL
const UMUrl = process.env.REACT_API_URL

const InsightAgent = () => {
  const dispatch = useDispatch();
  const { userInfo, functionsAndGoals } = useSelector((state: any) => ({
    userInfo: state.loginResource,
    functionsAndGoals: state.loginResource?.functionsAndGoals,
  }));
  const [isFuncsLoading, setIsFuncsLoading] = useState(true);

  // Roles are fetched here too: this screen can be landed on directly, without
  // going through Home, and the dropdown must not render off the stale list.
  useEffect(() => {
    setIsFuncsLoading(true);
    Promise.all([
      dispatch(fetchFunctionsAndGoals() as any) as Promise<any>,
      dispatch(fetchRoles() as any) as Promise<any>,
    ]).finally(() => {
      setIsFuncsLoading(false);
    });
  }, [dispatch]);

  const currentProject = useMemo(() =>
    userInfo?.company_data
      ?.find((cd: any) => cd.companyId === userInfo?.preferredCompany)
      ?.projectList?.find((p: any) => p.project_id === userInfo?.preferredProject),
    [userInfo?.company_data, userInfo?.preferredCompany, userInfo?.preferredProject]
  );

  const userPortfolioRoles = useMemo(() => {
    const roles = toPortfolioRoles(userInfo?.roleList);
    if (roles.length) return roles;

    return userInfo?.profileData
      ? userInfo.profileData.filter((role: any) => role.name !== "Workspace Owner")
      : [];
  }, [userInfo?.roleList, userInfo?.profileData]);

  if (isFuncsLoading) return <Loader />;

  return <>
    <InsightsAgents
      DOMAIN={baseURL}
      DOMAIN_UM={UMUrl}
      DOMAIN_MIDDLEWARE={middlewareURL}
      PROJECT_ID={userInfo?.preferredProject}
      USER_ID={userInfo?.id}
      PROJECT_NAME={currentProject?.project_name}
      PROJECT_BRAND_LIST={currentProject?.brands}
      USER_PORTFOLIO_ROLES={userPortfolioRoles}
      DROPDOWN_DATA_FUNCS_GOALS={functionsAndGoals?.data_value}
      USER_GROUP_LIST={userInfo?.userGroupList}
    />
  </>;
};

export default InsightAgent;
